// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2oTMA","header":"ReportDetails_header__10-Xx","title":"ReportDetails_title__3rKPm","left":"ReportDetails_left__3oi33"};